import React from "react";
import { SafetyCertificateOutlined } from "@ant-design/icons";

export default function ManagementPanel({ title, total, filters, children }) {
  return <>
    <section className="management-panel">
      <div className="management-panel-heading"><strong>{title}</strong><span className="management-count">{total}</span></div>
      <div className="management-panel-filters">{filters}</div>
      {children}
    </section>
    <div className="management-note"><SafetyCertificateOutlined /> Thao tác được hiển thị theo quyền truy cập của bạn.</div>
  </>;
}
